import { getMetricsInfo } from 'owa-calendar-compose-store-manager';

/**
 * Checks if we have shown timeSuggestions to the user
 */
export default function hasShownTimeSuggestions(formId: string): boolean {
    const metricsInfo = getMetricsInfo(formId);
    return metricsInfo?.timeSuggestionShown?.[0] > 0;
}
